import React from 'react';
import { TableInput } from '../../../../components/common';
import { CiLock } from 'react-icons/ci';
import { CiUnlock } from 'react-icons/ci';
import TagSelector from '../common/Tags';
import { MdPlaylistAddCircle } from 'react-icons/md';
import { Stack } from '@mui/material';
import { CustomIconButton } from '../../../../components/common/button/CustomIconButton';

const TBodyRow = ({
  index,
  isView,
  item,
  handleCompartmentData,
  handlePartAddModal,
}: any) => {
  const rowId = item?._id || item?._tempId;
  const handleInputChange = (
    fieldName: string,
    value: string | number | null
  ) => {
    handleCompartmentData(index, fieldName, value);
  };

  return (
    <React.Fragment key={rowId}>
      <tr>
        <th style={{ minWidth: '50px', textAlign: 'center' }}>{index + 1}</th>
        <td style={{ minWidth: '150px', textAlign: 'center' }}>
          <TableInput
            isView={isView}
            name="name"
            type="text"
            value={item?.name}
            onChange={(e) => {
              handleInputChange(e.target.name, e.target.value);
            }}
          />
        </td>
        <td
          style={{ minWidth: '150px', maxWidth: '320px', textAlign: 'center' }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <TagSelector
              tags={item?.initial_data?.length > 0 ? item?.initial_data : null}
              populateField={'ri_part_id'}
              fieldName1="part_number"
              fieldName2="quantity"
            />

            <CustomIconButton
              sx={{ pr: 0 }}
              tooltipTitle={'PICK PART'}
              onClick={() => {
                handlePartAddModal(index);
              }}
            >
              <MdPlaylistAddCircle
                style={{
                  fontSize: '30px',
                  color: '#f03e3e',
                  cursor: 'pointer',
                }}
              />
            </CustomIconButton>
          </Stack>
        </td>
        <td>
          {item?.isLocked ? (
            <CiLock
              style={{
                fontSize: '30px',
                color: '#f03e3e',
                cursor: 'not-allowed',
              }}
            />
          ) : (
            <CiUnlock
              style={{
                fontSize: '30px',
                color: '#28362b',
                cursor: 'not-allowed',
              }}
            />
          )}
        </td>
      </tr>
    </React.Fragment>
  );
};

export default TBodyRow;
